import { hasInternalModuleRoutePermission } from "@/util/permissions"
import i18next from "i18next"
import { lazy } from "react"
import { RouteObject } from "react-router-dom"

const ProtectedRoute = lazy(() => import("@/components/ProtectedRoute"))
const UniversityList = lazy(
  () => import("@/pages/Universities/UniversitiesList"),
)

const route: RouteObject = {
  path: "/universities",
  element: (
    <ProtectedRoute
      hasPermission={hasInternalModuleRoutePermission("organisation")}
      redirectTo="/"
    >
      <UniversityList />
    </ProtectedRoute>
  ),
  handle: {
    pageTitle: () =>
      `${i18next.t("pageTitle.universitiesPage", {
        ns: "organisation",
      })} - ${i18next.t("label.hitseeker", { ns: "common" })}`,
    title: () =>
      i18next.t("pageTitle.universitiesPage", {
        ns: "organisation",
      }),
    crumb: () =>
      i18next.t("pageTitle.universitiesPage", {
        ns: "organisation",
      }),
  },
}

export default route
